// extracted by mini-css-extract-plugin
module.exports = {"buy-button":"unlock-button_buy-button__CuFQW","button-text-small":"unlock-button_button-text-small__gx9CM","button-text-large":"unlock-button_button-text-large__ueuzO"};